<ng-template [ngIf]="node && !node.data.hide">
    <div class="img-box"
        [ngStyle]="{
            'height': (node.gData.imgHeight || node.gData.boxHeight) + 'px',
            'width': (node.gData.imgWidth || node.gData.boxWidth) + 'px',
            'background': node.gData.background,
            'z-index': node.gData.zIndex,
        }"
        (click)="onClick($event)"
        (mouseover)="onMouseOver($event)"
        (mouseout)="onMouseOut()">
        <div class="box {{node.gData.state}}"
            [ngStyle]="{
                'height': node.gData.boxHeight + 'px',
                'width': node.gData.boxWidth + 'px',
                'top': (node.gData.imgHeight ? node.gData.imgHeight - node.gData.boxHeight : 0) + 'px',
                'left': (node.gData.imgWidth ? node.gData.imgWidth - node.gData.boxWidth : 0) + 'px'
            }"
            [ngClass]="{
                'active': node.selected,
                'hover': hover,
                'red': node.gData.color === 'red',
                'yellow': node.gData.color === 'yellow'
            }"
            [title]="node.gData.tips || ''">
            <ng-container [ngTemplateOutlet]="node.gData.template"
                [ngTemplateOutletContext]="{
                    $implicit: node,
                    data: node.data
                }">
            </ng-container>
            <ng-container *ngFor="let child of node.children">
                <app-graph-node class="node"
                    *ngIf="child.gData"
                    [node]="child"
                    [ngStyle]="{
                        'left': child.gData.position.left ? child.gData.position.left + 'px' : '',
                        'top':  child.gData.position.top ? child.gData.position.top + 'px' : '',
                        'right': child.gData.position.right ? child.gData.position.right + 'px' : '',
                        'bottom': child.gData.position.bottom ? child.gData.position.bottom + 'px' : ''
                    }">
                </app-graph-node>
            </ng-container>
        </div>
    </div>
</ng-template>
